module.exports = __webpack_public_path__ + "img/bank_transfer.6f0c07fc.svg";